"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _theme = _interopRequireDefault(require("./styles/theme"));
var _RoundedButton = _interopRequireDefault(require("./Buttons/RoundedButton"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _color = _interopRequireDefault(require("./styles/color"));
var _Text = _interopRequireDefault(require("./Text"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var PaginatorContainer = _styledComponents["default"].div.withConfig({
  displayName: "PaginatorContainer",
  componentId: "sc-il7k16-0"
})(["display:inline-flex;@media only screen and (max-width:823px){display:table;}"]);
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-il7k16-1"
})(["display:inherit;margin-left:10px;margin-right:10px;"]);
/* istanbul ignore next */
var PageNumber = _styledComponents["default"].div.withConfig({
  displayName: "PageNumber",
  componentId: "sc-il7k16-2"
})(["color:", ";float:left;text-decoration:none;border-radius:50%;background-color:", ";font-family:Raleway,sans-serif;font-style:normal;font-weight:500;font-size:18px;text-transform:uppercase;cursor:pointer;width:40px;height:40px;line-height:40px;text-align:center;vertical-align:middle;:hover{background-color:", "}"], function (props) {
  return props.textColor;
}, function (props) {
  return props.theme;
}, function (props) {
  return props.hoverColor;
});
PageNumber.displayName = 'PageNumber';
/* istanbul ignore next */
var PageBreak = _styledComponents["default"].div.withConfig({
  displayName: "PageBreak",
  componentId: "sc-il7k16-3"
})(["color:", ";float:left;text-decoration:none;font-family:Raleway,sans-serif;font-style:normal;font-weight:500;font-size:18px;text-transform:uppercase;width:40px;height:40px;line-height:40px;text-align:center;vertical-align:middle;"], function (props) {
  return _theme["default"].lightTextDefault;
});
PageBreak.displayName = 'PageBreak';
var ButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "ButtonContainer",
  componentId: "sc-il7k16-4"
})(["@media only screen and (max-width:823px){margin-bottom:10px;margin-top:10px;}"]);
ButtonContainer.displayName = 'ButtonContainer';

/* istanbul ignore next */
var MobileContainer = _styledComponents["default"].div.withConfig({
  displayName: "MobileContainer",
  componentId: "sc-il7k16-5"
})(["border:1px solid ", ";box-sizing:border-box;border-radius:29px;width:fit-content;h3{display:inline;vertical-align:super;padding-left:33px;padding-right:33px;}"], function (props) {
  return props.theme;
});
MobileContainer.displayName = 'MobileContainer';

/* istanbul ignore next */
var Span = _styledComponents["default"].span.withConfig({
  displayName: "Span",
  componentId: "sc-il7k16-6"
})(["cursor:", ";"], function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
});
Span.displayName = 'Span';
var Paginator = /*#__PURE__*/function (_Component) {
  _inherits(Paginator, _Component);
  var _super = _createSuper(Paginator);
  function Paginator(props) {
    var _this;
    _classCallCheck(this, Paginator);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "goToPrevPage", function () {
      var previousButtonDisabled = _this.state.previousButtonDisabled;
      if (previousButtonDisabled) {
        return;
      }
      _this.setState(function (state) {
        return {
          selected: state.selected - 1,
          previousButtonDisabled: state.selected === 2,
          nextButtonDisabled: false
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "goToNextPage", function () {
      var nextButtonDisabled = _this.state.nextButtonDisabled;
      if (nextButtonDisabled) {
        return;
      }
      _this.setState(function (state) {
        return {
          selected: state.selected + 1,
          previousButtonDisabled: false,
          nextButtonDisabled: _this.props.pageCount === state.selected + 1
        };
      });
    });
    if (props.pageRangeDisplayed < 5) {
      throw new Error('Page range must be at least 5');
    }
    _this.state = {
      selected: props.initialPage,
      previousButtonDisabled: true,
      nextButtonDisabled: props.initialPage === props.pageCount || props.pageCount <= 1,
      isMobile: window.innerWidth <= 412
    };
    return _this;
  }
  _createClass(Paginator, [{
    key: "setIsMobile",
    value: function setIsMobile(isMobile) {
      this.setState({
        isMobile: isMobile
      });
    }

    /* istanbul ignore next */
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      this.setIsMobile(window.innerWidth <= 412);
    }

    /* istanbul ignore next */
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      window.addEventListener('resize', function () {
        return _this2.onWindowResize();
      });
    }

    /* istanbul ignore next */
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      window.removeEventListener('resize', function () {
        return _this3.onWindowResize();
      });
    }

    /* istanbul ignore next */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var selectedProp = this.props.selected;
      var selectedState = this.state.selected;
      if (prevState.selected !== selectedState) {
        this.props.onPageChange(selectedState);
      } else if (selectedProp !== selectedState) {
        this.setPage(selectedProp);
      }
    }

    /* istanbul ignore next */
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.selected !== this.state.selected) {
        this.setPage(nextProps.selected);
      }
      if (nextProps.pageCount !== this.props.pageCount) {
        this.setState({
          nextButtonDisabled: this.state.selected === nextProps.pageCount || nextProps.pageCount <= 1
        });
      }
    }
  }, {
    key: "setPage",
    value: function setPage(selected) {
      this.setState(function (state, props) {
        return {
          selected: selected,
          previousButtonDisabled: selected === 1 || props.pageCount <= 1,
          nextButtonDisabled: selected === props.pageCount || props.pageCount <= 1
        };
      });
    }
  }, {
    key: "getPageBreak",
    value: function getPageBreak() {
      return /*#__PURE__*/_react["default"].createElement(PageBreak, null, this.props.breakLabel);
    }
  }, {
    key: "getPages",
    value: function getPages() {
      var _this$props = this.props,
        pageRangeDisplayed = _this$props.pageRangeDisplayed,
        pageCount = _this$props.pageCount;
      var selected = this.state.selected;
      if (pageRangeDisplayed >= pageCount) {
        return this.generateButtonList(pageCount);
      }
      var pageBreak = this.getPageBreak();
      if (selected <= pageRangeDisplayed - 3) {
        var beginningRange = pageRangeDisplayed - 2;
        var endingRange = 2;
        var beginnerList = this.generateButtonList(beginningRange);
        var endingList = this.generateButtonList(endingRange, pageCount - (endingRange - 1));
        return /*#__PURE__*/_react["default"].createElement(Container, null, beginnerList, pageBreak, endingList);
      }
      if (selected > pageCount - (pageRangeDisplayed - 3)) {
        var _beginningRange = 2;
        var _endingRange = pageRangeDisplayed - 2;
        var _beginnerList = this.generateButtonList(_beginningRange);
        var _endingList = this.generateButtonList(_endingRange, pageCount - (_endingRange - 1));
        return /*#__PURE__*/_react["default"].createElement(Container, null, _beginnerList, pageBreak, _endingList);
      }
      var medianButtons = this.generateButtonList(pageRangeDisplayed - 2, selected - parseInt((pageRangeDisplayed - 2) / 2));
      return /*#__PURE__*/_react["default"].createElement(Container, null, this.getButton(1, false), pageBreak, medianButtons, pageBreak, this.getButton(pageCount, false));
    }
  }, {
    key: "generateList",
    value: function generateList(count, start) {
      start = start || 1;
      var i = 0;
      var numbers = new Array(count);
      while (i < count) {
        numbers[i] = start + i;
        i++;
      }
      return numbers;
    }
  }, {
    key: "generateButtonList",
    value: function generateButtonList(count, start) {
      var _this4 = this;
      var selected = this.state.selected;
      var medianNumbers = this.generateList(count, start);
      return medianNumbers.map(function (num) {
        return _this4.getButton(num, num === selected);
      });
    }
  }, {
    key: "getButton",
    value: function getButton(value, isSelected) {
      var _this5 = this;
      var selectedTheme = isSelected ? this.props.theme || _theme["default"].info : 'auto';
      var hoverColor = isSelected ? this.props.theme || _theme["default"].info : _theme["default"].lightGreyHover;
      var textColor = isSelected ? _theme["default"].white : _theme["default"].lightTextDefault;
      return /*#__PURE__*/_react["default"].createElement(PageNumber, {
        onClick: function onClick() {
          return _this5.setPage(value);
        },
        theme: selectedTheme,
        hoverColor: hoverColor,
        textColor: textColor,
        key: value
      }, value);
    }
  }, {
    key: "getDesktopPaginator",
    value: function getDesktopPaginator() {
      var _this$state = this.state,
        previousButtonDisabled = _this$state.previousButtonDisabled,
        nextButtonDisabled = _this$state.nextButtonDisabled;
      var _this$props2 = this.props,
        previousLabel = _this$props2.previousLabel,
        nextLabel = _this$props2.nextLabel,
        theme = _this$props2.theme;
      var pages = this.getPages();
      return /*#__PURE__*/_react["default"].createElement(PaginatorContainer, null, /*#__PURE__*/_react["default"].createElement(ButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_RoundedButton["default"], {
        onClick: this.goToPrevPage,
        theme: theme,
        textTheme: theme,
        disabled: previousButtonDisabled,
        width: "150px"
      }, previousLabel)), pages, /*#__PURE__*/_react["default"].createElement(ButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_RoundedButton["default"], {
        onClick: this.goToNextPage,
        theme: theme,
        textTheme: theme,
        disabled: nextButtonDisabled,
        width: "150px"
      }, nextLabel)));
    }
  }, {
    key: "getMobilePaginator",
    value: function getMobilePaginator() {
      var theme = this.props.theme || _color["default"].info;
      var pageCount = this.props.pageCount;
      var _this$state2 = this.state,
        previousButtonDisabled = _this$state2.previousButtonDisabled,
        nextButtonDisabled = _this$state2.nextButtonDisabled,
        selected = _this$state2.selected;
      var text = "".concat(selected, " of ").concat(pageCount);
      return /*#__PURE__*/_react["default"].createElement(MobileContainer, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(Span, {
        onClick: this.goToPrevPage,
        disabled: previousButtonDisabled
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        iconName: "leftCircleArrow",
        size: "2x",
        color: theme
      })), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        text: text,
        fontWeight: "700",
        lineHeight: "22px",
        textSize: "h3",
        align: "center",
        fontColor: theme
      }), /*#__PURE__*/_react["default"].createElement(Span, {
        onClick: this.goToNextPage,
        disabled: nextButtonDisabled
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        iconName: "rightCircleArrow",
        size: "2x",
        color: theme
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var isMobile = this.state.isMobile;
      return isMobile ? this.getMobilePaginator() : this.getDesktopPaginator();
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Paginator;
}(_react.Component);
var _default = Paginator;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(PaginatorContainer, "PaginatorContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Paginator.js");
  reactHotLoader.register(Container, "Container", "/Users/crs/WebstormProjects/michelangelo/src/Components/Paginator.js");
  reactHotLoader.register(PageNumber, "PageNumber", "/Users/crs/WebstormProjects/michelangelo/src/Components/Paginator.js");
  reactHotLoader.register(PageBreak, "PageBreak", "/Users/crs/WebstormProjects/michelangelo/src/Components/Paginator.js");
  reactHotLoader.register(ButtonContainer, "ButtonContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Paginator.js");
  reactHotLoader.register(MobileContainer, "MobileContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Paginator.js");
  reactHotLoader.register(Span, "Span", "/Users/crs/WebstormProjects/michelangelo/src/Components/Paginator.js");
  reactHotLoader.register(Paginator, "Paginator", "/Users/crs/WebstormProjects/michelangelo/src/Components/Paginator.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/Paginator.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();